module.exports = __webpack_public_path__ + "img/logo2.46fa64b6.png";